/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Footer from "components/Footer/Footer.js";



import styles from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.js";

import mcCannLogo from 'assets/img/fpmccann white.png';

const useStyles = makeStyles(styles);

export default function footer() {
    const classes = useStyles();
    return (
        <div>
            <Footer theme="info" content={''}>
                <div className={classes.footer}>
                    <GridContainer>
                        <GridItem xs={12} sm={2} md={2}>
                            <h5>Services</h5>
                            <ul className={classes.linksVertical}>
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li>
                                    <Link to="/EditAccount">Edit Account</Link>
                                </li>
                                <li>
                                    <Link to="/ContactUs">Contact Us</Link>
                                </li>
                            </ul>
                        </GridItem>
                        <GridItem xs={12} sm={2} md={2}>
                            <h5>Useful Links</h5>
                            <ul className={classes.linksVertical}>
                                <li>

                                    <a href="https://fpmccann.co.uk" target="_blank" rel="noopener noreferrer">
                                        FP McCann Website
                                    </a>


                                </li>

                                <li>

                                    <a href="https://fpmccann.co.uk/wp-content/uploads/2021/06/Fencing_200122.pdf"
                                       download>
                                        Fencing Solutions PDF
                                    </a>


                                </li>
                            </ul>
                        </GridItem>
                        <GridItem xs={12} sm={4} md={4}>
                            <h5>Contact Us</h5>
                            <div className={classes.socialFeed}>
                                <div>
                                    <i className="fas fa-location-arrow"/>
                                    <p>
                                    Brascote Lane, Cadeby, Warwickshire
                                    </p>
                                </div>
                                <div>
                                    <i className="fas fa-phone" />
                                    <p>
                                        01455 290780
                                    </p>
                                </div>
                                <div>
                                    <i className="fas fa-mail-bulk" />
                                    <p>
                                        orders@fpmccann.co.uk
                                    </p>
                                </div>
                            </div>
                        </GridItem>

                        <GridItem xs={12} sm={3} md={3} >
                            <div className={classes.textCenter}>
                                <div>
                                    <div>
                                        <img
                                            src={mcCannLogo}
                                            height={80}
                                            alt="FPMcCannLogo"
                                        />
                                    </div>
                                    <div style={{ paddingTop: '8px' }}>
                                        <p>
                                            Copyright FP McCann Limited | Maintained by FP McCann I.T Department
                                        </p>
                                    </div>
                                </div>
                                <ul className={classes.socialButtons}>
                                    <li>
                                        <a href="https://www.youtube.com/watch?v=8oTMGPAqZYk" target="_blank" rel="noopener noreferrer" >
                                            <Button justIcon simple color="white">
                                                <i className="fab fa-youtube" />
                                            </Button>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://x.com/FPMcCann/" target="_blank" rel="noopener noreferrer">
                                            <Button justIcon simple color="white">
                                                <i className="fa-brands fa-x-twitter" />
                                            </Button>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://m.facebook.com/FP-McCann-110181082374851/" target="_blank" rel="noopener noreferrer">
                                            <Button justIcon simple color="white">
                                                <i className="fab fa-facebook" />
                                            </Button>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/fp-mccann/" target="_blank" rel="noopener noreferrer">
                                            <Button justIcon simple color="white">
                                                <i className="fab fa-linkedin-in"></i>
                                            </Button>
                                        </a>
                                    </li>
                                    {/*<li>*/}
                                    {/*    */}{/*<a href="https://www.pinterest.co.uk/fpmccann/" target="_blank" rel="noopener noreferrer">*/}
                                    {/*    */}{/*    <Button justIcon simple color="white">*/}
                                    {/*    */}{/*        <i class="fab fa-pinterest"></i>*/}
                                    {/*    */}{/*    </Button>*/}
                                    {/*    */}{/*</a>*/}
                                    {/*</li>*/}
                                    <li>
                                        <a href="https://www.instagram.com/fpmccann/" target="_blank" rel="noopener noreferrer">
                                            <Button justIcon simple color="white">
                                                <i className="fab fa-instagram" />
                                            </Button>
                                        </a>

                                    </li>
                                </ul>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
            </Footer>



        </div>
    );
}
